"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Container = _interopRequireDefault(require("../../Container"));
var _BilateralSymmetry = _interopRequireDefault(require("../../BilateralSymmetry"));
var _WholeWidth = _interopRequireDefault(require("../../WholeWidth"));
var _VerticalCenter = _interopRequireDefault(require("../../VerticalCenter"));
var _Article = _interopRequireDefault(require("../../Article"));
var _Image = _interopRequireDefault(require("../../Image"));
var _Share = _interopRequireDefault(require("../../Share"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
//todo 待删除
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Renderer = function Renderer(restProps) {
  return /*#__PURE__*/_react["default"].createElement(_WholeWidth["default"], null, /*#__PURE__*/_react["default"].createElement(_VerticalCenter["default"], {
    pc: {
      //组件特有样式
      backgroundImage: 'linear-gradient(135deg, #2D3CE3 0%, #006EFF 100%)',
      boxShadow: '0 2px 4px 0 rgba(3,27,78,0.06)',
      borderRadius: '4px 0 0 4px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Article["default"], __assign({
    titleStyle: {
      fontSize: ' 24px',
      color: '#FFFFFF',
      lineHeight: '36px',
      paddingBottom: '12px'
    },
    contentStyle: {
      fontSize: '14px',
      color: 'rgba(255,255,255,0.80)',
      lineHeight: '21px'
    },
    pc: {
      justifyContent: 'content',
      alignItems: 'center',
      background: 'none',
      margin: '0 24px'
    },
    mo: {
      paddingTop: '30px'
    }
  }, restProps)), restProps.shareList && (/*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: '0 24px 24px 24px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Share["default"], {
    className: 'benefit-class-white',
    shareList: restProps.shareList
  })))))));
};
var Thumbnail = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
    banner = props.banner,
    sharp = props.sharp,
    radius = props.radius,
    source = props.source,
    imageSrc = props.imageSrc,
    shareList = props.shareList,
    filedVideoBg = props.filedVideoBg,
    filedVideoList = props.filedVideoList,
    _a = props.imageLocation,
    imageLocation = _a === void 0 ? false : _a,
    className = props.className,
    onClick = props.onClick,
    record = props.record,
    restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "imageSrc", "shareList", "filedVideoBg", "filedVideoList", "imageLocation", "className", "onClick", "record"]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Container["default"], __assign({
    ref: ref
  }, restProps), !imageLocation ? (/*#__PURE__*/_react["default"].createElement(_BilateralSymmetry["default"], {
    pc: {
      maxHeight: '588px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_WholeWidth["default"], {
    pc: {
      width: '784px',
      height: '588px',
      flex: 'initial'
    },
    mo: {}
  }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    pc: {
      paddingTop: ''
    },
    mo: {
      paddingTop: 784 / 588 * 100 + '%'
    },
    source: imageSrc,
    filedVideoList: filedVideoList,
    filedVideoBg: filedVideoBg,
    record: record
  })), /*#__PURE__*/_react["default"].createElement(Renderer, __assign({}, restProps, {
    shareList: shareList
  })))) : (/*#__PURE__*/_react["default"].createElement(_BilateralSymmetry["default"], {
    mo: {
      flexDirection: 'column-reverse'
    }
  }, /*#__PURE__*/_react["default"].createElement(Renderer, __assign({}, restProps, {
    shareList: shareList
  })), /*#__PURE__*/_react["default"].createElement(_WholeWidth["default"], {
    pc: {
      width: '784px',
      height: '588px',
      flex: 'initial'
    },
    mo: {
      // height: '588px',
    }
  }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    filedVideoList: filedVideoList,
    filedVideoBg: filedVideoBg,
    pc: {
      paddingTop: '',
      borderTopRightRadius: '4px',
      borderBottomRightRadius: '4px'
    },
    mo: {
      paddingTop: 784 / 588 * 100 + '%'
    },
    source: imageSrc,
    record: record
  }))))));
});
Thumbnail.displayName = 'TCIThumbnail';
var _default = exports["default"] = Thumbnail;